import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const Container = styled(FocusNode)`
  width: 1920px;
  height: 1080px;
`
